import { Box, ButtonBase } from "@mui/material";
import { getShipperLogo } from "../../../../../utils/logomapper";
import { tokens } from "../../../../../theme";
import { useTranslation } from "react-i18next";
import Text from "../../../../theme/text/Text";

export const ProfileRow = ({ profileData, colorSettings, onEdit, onDelete, showShipperLogo = false }) => {
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                height:32,
                background:colorSettings.streamrule,
                borderRadius:4,
                px:0.5,
                display:"flex",
                alignItems:'center',
            }}
        >
            <Box
                sx={{
                    background:colorSettings.base,
                    color:colorSettings.background,
                    minWidth:80,
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    borderRadius:4,
                    height:24,
                }}
            >
                {profileData.count}
            </Box>
            <Box
                sx={{
                    display:"flex",
                    alignItems:'center',
                    ml:1.5,
                    gap:1,
                }}
            >
                {showShipperLogo && profileData.shipper && (
                    <Box
                        sx={{
                            height:24,
                            width:24,
                            "& svg" : {
                                height:24,
                                width:24,
                            }
                        }}
                    >
                        {getShipperLogo(profileData.shipper.type)}
                    </Box>
                )}
                <Text
                    sx={{
                        color:tokens("light").txt["primary"],
                    }}
                >
                    {profileData.profile?.name || t("unknown_profile")}
                </Text>
            </Box>

            <Box
                sx={{
                    ml:"auto",
                    display:"flex",
                    gap:1,
                }}
            >
                {profileData.shipper.type !== "bol" && (
                    <ButtonBase
                        onClick={onEdit}
                        sx={{
                            px:1.5,
                            height:24,
                            background:tokens("light").grey[400],
                            color:tokens("light").txt["light"],
                            fontFamily:"Roboto,sans-serif",
                            fontSize:14,
                            fontWeight:500,
                            borderRadius:3,
                        }}
                    >
                        {t("edit")}
                    </ButtonBase>
                )}
                <ButtonBase
                    onClick={onDelete}
                    sx={{
                        px:1.5,
                        height:24,
                        background:tokens("light").red[100],
                        color:tokens("light").red[400],
                        border: `1px solid ${tokens("light").red[400]}`,
                        fontFamily:"Roboto,sans-serif",
                        fontSize:14,
                        fontWeight:500,
                        borderRadius:3,
                    }}
                >
                    {t("delete")}
                </ButtonBase>
            </Box>
        </Box>
    );
};
